import { fromClassArray } from "fw-model";
import { QueueStatSummary } from "./foundatio";

export class AtsAppMetrics {
    Organizations: number;
    Applications: number;
    ApplicationAttachments: number;
    Programs: number;
    Forms: number;
}

export class AtsElasticStatSummary {
    Index: string;
    Health: string;
    Status: string;
    TotalDocuments: number;
    TotalDeleted: number;
    TotalStorageSize: number;
}

export class AtsSystemMetrics {
    @fromClassArray(AtsElasticStatSummary) Elasticsearch: AtsElasticStatSummary[] = [];
    Queues: { [key: string]: QueueStatSummary } = {};
}

export class SeasonMetrics {
    SeasonId: string;
    SeasonName: string;
    Applications: number;
    ApplicationAttachments: number;
    Programs: number;
    Forms: number;
    LastSyncDate: string | null;
}

export class AtsOrgMetrics {
    @fromClassArray(SeasonMetrics) SeasonMetrics: SeasonMetrics[] = [];
}
